<br>
<div class="container st-form">
  <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
    <app-st-button [idVal]="'sign-in-button-id'" [label]="'Sign In'" [primary]="true"
                   (click)="this.onSignIn()"></app-st-button>
    <app-st-button [idVal]="'sign-up-button-id'" [label]="'Sign Up'" [primary]="true"
                   (click)="this.onSignUp()"></app-st-button>
  </div>
</div>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <nav class="navbar navbar-expand-lg st-navbar">
      <div class="container-fluid">
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <a class="nav-link" href="#">Home</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">How We Work</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">Products</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">Testimonials</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">About Us</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="col-8">
      <h1>Welcome to Scalanthropy</h1>
    </div>
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">

    </div>
  </div>

  <div class="container st-form">
    <span><h2>About Us</h2></span>
    <div class="row pt-2">
      <div class="col">
        <span>At Scalanthropy, we enable nonprofits to better scale their operations and ultimately fulfill
          their missions of Philanthropy </span>
      </div>
      <div class="col">

      </div>
    </div>
    <div class="row pt-2">
      <div class="col">

      </div>
      <div class="col">

      </div>
    </div>
    <div class="row pt-2">
      <div class="col">

      </div>
      <div class="col">

      </div>
    </div>
    <div class="row pt-2">
      <div class="col">

      </div>
      <div class="col">

      </div>
      <div class="col">

      </div>
    </div>
    <div class="row pt-2">
      <div class="col">

      </div>
      <div class="col">

      </div>
      <div class="col">

      </div>
    </div>
    <br><br>
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">

    </div>
  </div>
</div>
